import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-317ae2ff"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
    ref: "form",
    model: $data.form,
    class: "form1",
    rules: $data.rules
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "公司名称",
      prop: "company"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "100%"
        },
        modelValue: $data.form.company,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.company = $event),
        filterable: "",
        remote: "",
        "value-key": "'name'",
        "reserve-keyword": "",
        placeholder: "请输入公司名称",
        "remote-method": $options.remoteMethod,
        onChange: $options.handleChange,
        loading: $data.loading
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.name,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "remote-method", "onChange", "loading"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "客户户号",
      prop: "account"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "100%"
        },
        "value-key": "'account'",
        modelValue: $data.form.account,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.account = $event),
        filterable: "",
        remote: "",
        placeholder: "请输入客户户号",
        "remote-method": $options.remoteMethod2,
        onChange: $options.handleChange,
        loading: $data.loading1
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options3, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.account,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "remote-method", "onChange", "loading"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "联系电话",
      prop: "contactTel",
      style: {
        "margin-bottom": "30px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "100%"
        },
        modelValue: $data.form.contactTel,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.contactTel = $event),
        filterable: "",
        "value-key": "'contactTel'",
        remote: "",
        placeholder: "请输入联系电话",
        "remote-method": $options.remoteMethod1,
        onChange: $options.handleChange,
        loading: $data.loading1
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options1, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.contactTel,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "remote-method", "onChange", "loading"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "报障类型",
      prop: "subTypeId",
      style: {
        "margin-bottom": "30px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "100%"
        },
        modelValue: $data.form.subTypeId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.subTypeId = $event),
        placeholder: "请选择报障类型"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options2, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "反馈内容",
      prop: "content",
      style: {
        "margin-bottom": "30px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        type: "textarea",
        modelValue: $data.form.content,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.content = $event),
        placeholder: "请输入反馈内容",
        rows: "10",
        maxlength: "600"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      class: "btn",
      onClick: $options.handleSubmit
    }, {
      default: _withCtx(() => [_createTextVNode("提交")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["model", "rules"])]);
}